import { render, staticRenderFns } from "./BfChip.vue?vue&type=template&id=66ca0200&"
import script from "./BfChip.vue?vue&type=script&lang=js&"
export * from "./BfChip.vue?vue&type=script&lang=js&"
import style0 from "./BfChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports